/**
 * Delete
 */

import Config from './Config';
import Util from './Util';

class Loading {

	private $node: any;

	private _id: any;

	private name: string;

	private _$node: any;

	constructor( $node: any ) {
		this.$node = $node;
		this._id = this.$node.attr( 'id' );
		this.name = 'ncCommunityLoader';
		this._$node = jQuery( `<div class="${this.name} nc-community-loader"><div class="loader-circle"></div></div>` );
	}

	public setUI() {
		this.$node.append( this._$node );
	}

	public showTop() {
		this.$node.prepend( this._$node );
		this.show();
	}

	public showBottom() {
		this.$node.append( this._$node );
		this.show();
	}

	public show() {
		jQuery( `#${this._id} .${this.name}` ).addClass( 'is-show' );
	}

	public hide() {
		jQuery( `#${this._id} .${this.name}` ).removeClass( 'is-show' );
	}

	public remove() {
		jQuery( `#${this._id} .${this.name}` ).remove();
	}
}

export default Loading;
